import { Component, forwardRef, EventEmitter, OnInit, Input, Output, ViewChild } from '@angular/core';
import { EmailValidator, FormBuilder, FormGroup, Validators, FormArray } from '@angular/forms';
import {Message, OverlayPanel, SelectItem, ConfirmationService} from 'primeng/primeng';
import { DomSanitizer } from '@angular/platform-browser';

//constants

import * as ent from '../../entities/index'
import * as serv from '../../services/index'

//components
import {MessageHandlerComponent} from './MessageHandler.component';

//constants
import { Constants }         from '../../constants/Constants';
import { validateConfig } from '@angular/router/src/config';


@Component({
  selector: 'my-usermessage',
  templateUrl: './UserMessage.component.html'
})
export class UserMessageComponent implements OnInit {

    public msgs: Message[] = [];
    public blocked: boolean;  
    public userMessage: ent.UserMessage;
    userInfo: ent.UserInfo;

    @ViewChild(MessageHandlerComponent) messageHandlerComponent: MessageHandlerComponent;

    
    constructor(private domainDataService: serv.DomainDataService, private sanitizer: DomSanitizer, private authenticationService: serv.AuthenticationService) 
    {
        
    }

    ngOnInit(): void {
      this.userInfo = this.authenticationService.getUserInfo();
      this.getUserMessage();        
    }

    getUserMessage(){
      let request: ent.GetDataRequest = {Employee: this.userInfo.Employee};
      this.domainDataService.getUserMessages(request).subscribe(x=>{
        if (x.length > 0){
          this.userMessage = x[0];
        }
      })
    }

    showMessage(): boolean{
      var val: boolean = false;
      if (this.userMessage != null && this.userMessage.Enabled && this.userMessage.MessageText != ""){
        val = true;
      }
      return val;
    }

}